import { render, staticRenderFns } from "./ItemDisountFilter.vue?vue&type=template&id=05fbc2f1&"
import script from "./ItemDisountFilter.vue?vue&type=script&lang=js&"
export * from "./ItemDisountFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports